export const LocaleEnum = {
  DE: 'de-DE',
  EN: 'en-DE'
} as const;

export type TLocales = (typeof LocaleEnum)[keyof typeof LocaleEnum];
